import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Input from "../../../ui/Input/Input";
import Button from "../../../ui/Button/Button";
import ConsentmentTemplate from "../ConsentmentTemplate/ConsentmentTemplate";
import Container from "../../../ui/Container/Container";
import { AuthContext } from "../../../context/AuthContext";
import { validateEmail, getReceiversEmail } from "../../../util/email";
import { updatePatientsInfo, sendEmail } from "../../../db/users";

import "./PatientsAgreement.css";

function PatientsAgreement() {
  const authCtx = useContext(AuthContext);
  const [requestData, setRequestData] = useState(true);
  const [ciData, setCiData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const patient = location.state.patient;
  const doctor = location.state.doctor;
  const navigateTo = location.state.navigateTo;

  const doctorFullName = `${doctor.name} ${doctor.lastName} ${doctor.surName}`;

  const [patientCiName, setPatientCiName] = useState(patient.patientName);
  const [firstWitnessName, setFirstWitnessName] = useState("");
  const [firstWitnessRelationship, setFirstWitnessRelationShip] = useState("");
  const [firstWitnessAddress, setFirstWitnessAdress] = useState("");
  const [secondWitnessName, setSecondWitnessName] = useState("");
  const [secondWitnessRelationship, setSecondtWitnessRelationShip] =
    useState("");
  const [secondWitnessAddress, setSecondWitnessAdress] = useState("");
  const [ciMailTo, setCiMailTo] = useState("");

  const [dataInvalid, setDataInvalid] = useState({
    patientCiName: false,
    firstWitnessName: false,
    firstWitnessRelationship: false,
    firstWitnessAddress: false,
    secondWitnessName: false,
    secondWitnessRelationship: false,
    secondWitnessAddress: false,
    ciMailTo: false,
  });

  const [isUpdating, setIsUpdating] = useState(false);

  function updateInputValueHandler(inputType, e) {
    const enteredValue = e.target.value;
    switch (inputType) {
      case "patientCiName":
        setPatientCiName(enteredValue);
        break;
      case "firstWitnessName":
        setFirstWitnessName(enteredValue);
        break;
      case "firstWitnessRelationship":
        setFirstWitnessRelationShip(enteredValue);
        break;
      case "firstWitnessAddress":
        setFirstWitnessAdress(enteredValue);
        break;
      case "secondWitnessName":
        setSecondWitnessName(enteredValue);
        break;
      case "secondWitnessRelationship":
        setSecondtWitnessRelationShip(enteredValue);
        break;
      case "secondWitnessAddress":
        setSecondWitnessAdress(enteredValue);
        break;
      case "ciMailTo":
        setCiMailTo(enteredValue);
        break;
    }
  }

  function generateConsent() {
    if (validateConsentmentData()) {
      const consentmentInfo = {
        patientCiName,
        firstWitnessName,
        firstWitnessRelationship,
        firstWitnessAddress,
        secondWitnessName,
        secondWitnessRelationship,
        secondWitnessAddress,
        ciMailTo,
        doctorFullName,
        consentDate: new Date(),
      };
      setCiData(consentmentInfo);
      setRequestData(false);
    }
  }

  function validateConsentmentData() {
    const patientCiNameIsValid = patientCiName.trim().length > 0;
    const firstWitnessNameIsValid = firstWitnessName.trim().length > 0;
    const firstWitnessRelationshipIsValid =
      firstWitnessRelationship.trim().length > 0;
    const firstWitnessAddressIsValid = firstWitnessAddress.trim().length > 0;
    const secondWitnessNameIsValid = secondWitnessName.trim().length > 0;
    const secondWitnessRelationshipIsValid =
      secondWitnessRelationship.trim().length > 0;
    const secondWitnessAddressIsValid = secondWitnessAddress.trim().length > 0;
    const ciMailToIsValid = validateEmail(ciMailTo.trim());

    if (
      !patientCiNameIsValid ||
      !firstWitnessNameIsValid ||
      !firstWitnessRelationshipIsValid ||
      !firstWitnessAddressIsValid ||
      !secondWitnessNameIsValid ||
      !secondWitnessRelationshipIsValid ||
      !secondWitnessAddressIsValid ||
      !ciMailToIsValid
    ) {
      alert("Revisa los datos que ingresaste.");
      setDataInvalid({
        patientCiName: !patientCiName.length,
        firstWitnessName: !firstWitnessName.length,
        firstWitnessRelationship: !firstWitnessRelationship.length,
        firstWitnessAddress: !firstWitnessAddress.length,
        secondWitnessName: !secondWitnessName.length,
        secondWitnessRelationship: !secondWitnessRelationship.length,
        secondWitnessAddress: !secondWitnessAddress.length,
        ciMailTo: !validateEmail(ciMailTo),
      });
      return false;
    }
    setDataInvalid({
      patientCiName: false,
      firstWitnessName: false,
      firstWitnessRelationship: false,
      firstWitnessAddress: false,
      secondWitnessName: false,
      secondWitnessRelationship: false,
      secondWitnessAddress: false,
      ciMailTo: false,
    });
    return true;
  }

  async function onAcceptHandler() {
    setIsUpdating(true);
    const data = {
      consentmentInfo: {
        patientCiName,
        firstWitnessName,
        firstWitnessRelationship,
        firstWitnessAddress,
        secondWitnessName,
        secondWitnessRelationship,
        secondWitnessAddress,
        ciMailTo: ciMailTo,
        doctorFullName,
        consentDate: new Date(),
      },
      patientAgreed: true,
    };

    const receivers = getReceiversEmail(
      process.env.REACT_APP_CONSENTMENT_RECEIVERS
    );
    receivers.push({ email: doctor.email, name: doctorFullName });
    receivers.push({
      email: data.consentmentInfo.ciMailTo,
      name: data.consentmentInfo.patientCiName,
    });

    let html = `<style>
    .main {
      background-color: #223843;
      padding: 20px;
      border-radius: 20px;
    }
    .title {
      font-size: 24px;
      color: grey;
    }
    .text {
      font-size: 20px;
      color: #e8eef2;
    }
    .button {
      width: 100px;
      padding: 10px;
      background-color: #119da4;
      border-radius: 8px;
    }
    a {
      text-decoration: none;
      color: white;
    }
  </style>
  
  <html>
    <div class="main">
      <p class="title">Hola ${patientCiName}</p>
      <p class="text">
        Has recibido este correo porque se generó un consentimiento informado en
        el app Atrare ADR Sienna, da click en el enlace para descargarlo
      </p>
      <a href="${process.env.REACT_APP_WEB_URL}/#/downloadconsentment/${authCtx.userId}/${patient.key}" target="_blank"
        ><div class="button">
          <p>Descarga el consentimiento informado</p>
        </div></a
      >
    </div>
  </html>
  `;

    const response = await sendEmail(
      "Atrare ADR Sienna Consentimiento informado",
      html,
      receivers
    );

    if (response === "OK") {
      alert("Se ha aceptado el consentimiento informado");
      await updatePatientsInfo(
        `${patient.key}/`,
        authCtx.userId,
        data,
        authCtx.token
      );
      navigate(navigateTo, { state: { patientKey: patient.key } });
    } else {
      alert(
        "No se ha podido mandar el consentimiento informado a tu correo, contacta al administrador"
      );
    }
    setIsUpdating(false);
  }

  function onReturnHandler() {
    setRequestData(true);
  }

  if (isUpdating) {
    return <p>Confirmando datos del consentimiento informado...</p>;
  }

  return (
    <Container title="Consentimiento informado" backNavigation="/mainDoctor">
      {requestData && (
        <div style={{ height: "100%" }}>
          <p className="paTitle">Datos para consentimiento informado</p>
          <div className="paForm">
            <div className="paSection">
              <span className="paLabel">Datos</span>
            </div>
            <Input
              label="Nombre del participante o su representante legal:"
              onUpdateValue={updateInputValueHandler.bind(
                this,
                "patientCiName"
              )}
              value={patientCiName}
              isInvalid={dataInvalid.patientCiName}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <div className="paSection">
              <span className="paLabel">Testigo 1</span>
            </div>
            <Input
              label="Nombre completo:"
              onUpdateValue={updateInputValueHandler.bind(
                this,
                "firstWitnessName"
              )}
              value={firstWitnessName}
              isInvalid={dataInvalid.firstWitnessName}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <Input
              label="Relación con el paciente:"
              onUpdateValue={updateInputValueHandler.bind(
                this,
                "firstWitnessRelationship"
              )}
              value={firstWitnessRelationship}
              isInvalid={dataInvalid.firstWitnessRelationship}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <Input
              label="Domicilio:"
              onUpdateValue={updateInputValueHandler.bind(
                this,
                "firstWitnessAddress"
              )}
              value={firstWitnessAddress}
              isInvalid={dataInvalid.firstWitnessAddress}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <div className="paSection">
              <span className="paLabel">Testigo 2</span>
            </div>
            <Input
              label="Nombre completo:"
              onUpdateValue={updateInputValueHandler.bind(
                this,
                "secondWitnessName"
              )}
              value={secondWitnessName}
              isInvalid={dataInvalid.secondWitnessName}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <Input
              label="Relación con el paciente:"
              onUpdateValue={updateInputValueHandler.bind(
                this,
                "secondWitnessRelationship"
              )}
              value={secondWitnessRelationship}
              isInvalid={dataInvalid.secondWitnessRelationship}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <Input
              label="Domicilio:"
              onUpdateValue={updateInputValueHandler.bind(
                this,
                "secondWitnessAddress"
              )}
              value={secondWitnessAddress}
              isInvalid={dataInvalid.secondWitnessAddress}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <div className="paSection">
              <span className="paLabel">Datos adicionales</span>
            </div>
            <Input
              label="Correo electrónico al que llegará esta información:"
              onUpdateValue={updateInputValueHandler.bind(this, "ciMailTo")}
              keyboardType="email-address"
              value={ciMailTo}
              isInvalid={dataInvalid.ciMailTo}
              autoCorrect={false}
              autoCompleteType="off"
            />
            <div style={{ margin: 10 }}></div>
            <div className="paButtons">
              <Button onPress={generateConsent}>
                Generar consentimiento informado
              </Button>
            </div>
          </div>
        </div>
      )}
      {!requestData && ciData && (
        <div style={{ height: "96%" }}>
          <div style={{ height: "90%", overflowY: "auto" }}>
            <ConsentmentTemplate ciData={ciData} />
          </div>
          <div className="paButtons">
            <div style={{ minWidth: 120 }}>
              <Button onPress={onReturnHandler}>Regresar</Button>
            </div>
            <div style={{ minWidth: 120 }}>
              <Button onPress={onAcceptHandler}>Acepto</Button>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
}

export default PatientsAgreement;
